# Getting Started

Welcome to Gnomux. This guide will help you get up and running.

## Signing In

Gnomux is invite-only during the private beta. Sign in from the splash screen
to continue to the app — see [Sign In](/help/sign-in) for details.

## Keyboard Shortcuts

Use <KbdGroup><Mod /> + <Kbd>S</Kbd></KbdGroup> to save your work.
